import { BaseViewStore, QueryPickerStore, BaasicDropdownStore } from "core/stores";
import { PivotService } from 'application/pivot/services';
import { action, observable, runInAction } from 'mobx';
import moment from 'moment';
import { QueryUtility } from 'core/utils';
import _ from "lodash";

class PivotListViewStore extends BaseViewStore {
	@observable.ref accessor pivotData = [];
	@observable.ref accessor pivotTableProps = null;
	@observable accessor isLoading = true;
	@observable accessor cols = ['department','name'];

	constructor(rootStore) {
        super(rootStore);

        const pivotService = new PivotService(rootStore.application.baasic.apiClient);
        this.pivotService = pivotService;

        this.dateFromStore = new QueryPickerStore();
        this.dateToStore = new QueryPickerStore();

        this.queryUtility = new QueryUtility(this.rootStore, async filter => {
            runInAction(() => {
                this.isLoading = true;
            });

			if(filter.dateFrom != null && filter.dateTo != null){
				filter.dateFrom = new Date(filter.dateFrom) < new Date(filter.dateTo) ? filter.dateFrom: filter.dateTo;
				this.dateFromStore.setValue(new Date(filter.dateFrom));
			}
			await this.fetchGrid(filter);
            runInAction(() => {
                this.isLoading = false;
            });
        }, {});

        this.queryParams = rootStore.routerStore.routerState.queryParams;

        _.each(this.queryParams, (v,k)=>{
			this.queryUtility.filter.set(k,v);
		});

        this.queryUtility.fetch();

        this.queryUtility.onResetFilter = (filter) => {
			filter.dateFrom = moment().startOf('month').format('YYYY-MM-DD');
			filter.dateTo = moment().add(2,'M').endOf('month').format('YYYY-MM-DD');
            this.dateFromStore.setValue(new Date(filter.dateFrom));
			this.dateToStore.setValue(new Date(filter.dateTo));
            this.departmentStore.setValue(null);
        }

        this.departmentStore = new BaasicDropdownStore({
            textField: 'name',
			dataItemKey: 'name'
        }, {
            fetchFunc: () => {
                return [
						{name: "Billing" },
						{name: "Document" },
						{name: "Intake" },
						{name: "Payor" }
					];
			}
            
        });

        this.initialSet();
    }

	async initialSet(){
		this.queryParams.dateFrom = this.queryParams.dateFrom || moment().startOf('month').format('YYYY-MM-DD');
		this.queryParams.dateTo = this.queryParams.dateTo || moment().add(2,'M').endOf('month').format('YYYY-MM-DD');
		this.queryParams.department = this.queryParams.department || null;
		await this.fetchGrid(this.queryParams);
		this.departmentStore.filterAsync();
	}

	@action.bound
	async fetchGrid(filter) {
		const data = await this.getData({ 
			department: filter ? filter.department: null,
			page: 1,
			rpp: 10000,
			dateFrom: moment.utc(filter.dateFrom).startOf('day').format(),
			dateTo: moment.utc(filter.dateTo).endOf('day').format(),
		});
		this.setData(data.item);
	}

	@action.bound
	setData(data) {
		this.pivotData = data;		
	}

	@action.bound
	setProps(props) {
		this.pivotTableProps = props;		
	}
	
	async getData(params) {
		const response = await this.pivotService.find(params);
		return response.data;
	}

	@action.bound
	changeLayout(layout) {
		switch (layout) {
			case "team":
				this.cols = ['department','accountManager','name'];
				break;
			case "person":
				this.cols = ['department','name'];
				break;
			case "department":
				this.cols = ['department'];
				break;
			default:
				this.cols = ['department','name'];
				break;
		}
	}
}

export default PivotListViewStore;